import { Toaster as Sonner, toast } from 'sonner';
import type { ComponentProps } from 'react';

/** Toast surface, skinned to the --cad-* tokens. Mounts once at the shell level.
 *  aria-live is handled by sonner; toasts never steal focus. */
export function Toaster(props: ComponentProps<typeof Sonner>) {
  return (
    <Sonner
      position="bottom-right"
      gap={10}
      toastOptions={{
        classNames: {
          toast:
            'group flex items-center gap-3 rounded-lg border border-border bg-popover px-4 py-3 text-popover-foreground shadow-lg font-sans text-sm',
          title: 'text-sm font-medium',
          description: 'text-muted-foreground text-sm',
          actionButton:
            'rounded-md bg-primary px-2 py-1 text-xs font-medium text-primary-foreground',
          cancelButton: 'rounded-md bg-muted px-2 py-1 text-xs text-muted-foreground',
          error: 'border-destructive',
          closeButton: 'border-border bg-popover text-popover-foreground',
        },
      }}
      {...props}
    />
  );
}

export { toast };
